import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal';
import StatsBar from '../components/StatsBar';
import IMG from '../data/images';
import logo from '../assets/images/logo.webp';

const About = () => (
  <div>
    <section style={{ paddingTop: 130, paddingBottom: 70, background: 'linear-gradient(135deg,var(--navy),var(--navy-dark))', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
      <img src={IMG.about} alt="" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.15 }} />
      <div style={{ position: 'relative', zIndex: 2 }}>
        <img src={logo} alt="" style={{ height: 90, margin: '0 auto 16px' }} />
        <h1 style={{ fontFamily: 'var(--fh)', fontSize: '2.6rem', color: '#fff', marginBottom: 12 }}>About <span style={{ color: 'var(--gold)' }}>Finland Early Years</span></h1>
        <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 500, margin: '0 auto', lineHeight: 1.8 }}>A school inspired by the world's best education system — built with love, designed with purpose.</p>
      </div>
    </section>

    <section style={{ padding: '90px 24px' }}>
      <div className="container" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 48, alignItems: 'center' }} id="abt-grid">
        <Reveal direction="left">
          <img src={IMG.teacher} alt="" style={{ borderRadius: 20, width: '100%', height: 400, objectFit: 'cover', boxShadow: 'var(--shadow-l)' }} />
        </Reveal>
        <Reveal direction="right" delay={0.1}>
          <div className="gold-bar" style={{ margin: '0 0 16px' }} />
          <h2 style={{ fontFamily: 'var(--fh)', fontSize: '2rem', color: 'var(--navy)', marginBottom: 16 }}>Our Story</h2>
          <p style={{ color: 'var(--body)', lineHeight: 1.9, marginBottom: 18 }}>Finland Early Years was born from a simple yet powerful idea: every child deserves the kind of education that Finland offers. An education where play is not a reward — it is the method.</p>
          <p style={{ color: 'var(--body)', lineHeight: 1.9, marginBottom: 18 }}>Our founders travelled to Finland, trained with Finnish educators, and brought back not just a curriculum — but a philosophy. A belief that the early years are about preparing children for life, not just school.</p>
          <p style={{ color: 'var(--body)', lineHeight: 1.9 }}>Today, Finland Early Years is a thriving community of curious learners, dedicated educators, and trusting parents — all united by the Finnish belief that happy children learn best.</p>
        </Reveal>
      </div>
      <style>{`@media(max-width:768px){#abt-grid{grid-template-columns:1fr!important;}}`}</style>
    </section>

    <section className="sec-alt" style={{ padding: '90px 24px' }}>
      <div className="container">
        <Reveal><div className="gold-bar" /><h2 className="sec-heading">Our Core Values</h2><p className="sec-sub">The pillars that guide everything we do.</p></Reveal>
        <div className="g4">
          {[{ i: '🎯', t: 'Child-Centred', d: 'Every decision starts with the child — their pace, their interests, their joy.' },
            { i: '🌍', t: 'Global Citizens', d: "We raise children curious about the world and kind to everyone in it." },
            { i: '💡', t: 'Lifelong Learning', d: "We don't teach what to think — we teach how to learn." },
            { i: '❤️', t: 'Warmth & Trust', d: 'A child who feels safe will dare to explore. Trust comes first, always.' }
          ].map((v, j) => (
            <Reveal key={j} delay={j * 0.08}>
              <div className="card" style={{ textAlign: 'center', height: '100%' }}>
                <div style={{ fontSize: '2.2rem', marginBottom: 10 }}>{v.i}</div>
                <h3 style={{ fontFamily: 'var(--fh)', color: 'var(--navy)', fontSize: '1.05rem', marginBottom: 8 }}>{v.t}</h3>
                <p style={{ color: 'var(--body)', lineHeight: 1.7, fontSize: '0.88rem' }}>{v.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <StatsBar />

    <section style={{ padding: '70px 24px', background: 'var(--gold)', textAlign: 'center' }}>
      <h2 style={{ fontFamily: 'var(--fh)', fontSize: '2rem', color: 'var(--navy)', marginBottom: 14 }}>Come See the Difference</h2>
      <Link to="/admissions" className="btn btn-navy">Book a Visit</Link>
    </section>
  </div>
);
export default About;
